import React, { useState, useMemo, useCallback, useContext } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Modal, Spin } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../Styles/style.css";
import Flag from 'react-world-flags';  // Importation de react-world-flags
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';  // Importation de useTranslation
import { deleteTypeInspection, getTypeInspection } from "../services/typeApi";
import AddEditType from "../component/AddEditType";
import DetailType from "../component/DetailType";
const TypeInspections = () => {
  const { t } = useTranslation();  // Hook pour récupérer les traductions
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  document.title = `Type-Inspections | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteTargetFullName, setDeleteTargetFullName] = useState("");

  const { isLoading, isError, error, data: types } = useQuery("types", getTypeInspection);

  const toggleAddEditModal = useCallback((type = null) => {
    setSelectedType(type);
    setIsAddEditModalOpen(prev => !prev);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
  }, [isDetailModalOpen]);

  const handleEdit = (type) => {
    toggleAddEditModal(type);
  };

  const toggleDetailModal = useCallback((type = null) => {
    setSelectedType(type);
    setIsDetailModalOpen(prev => !prev);
    if (isAddEditModalOpen) setIsAddEditModalOpen(false);
  }, [isAddEditModalOpen]);

  
  const handleDetail = (type) => {
    toggleDetailModal(type);
  };

  const handleDelete = async (typeId) => {
    try {
      await deleteTypeInspection(typeId);
      queryClient.invalidateQueries("types");
      toast.success("Le type inspection a été supprimé avec succès 🎉");
    } catch (error) {
      console.error("Error deleting driver:", error);
      toast.error(`😔 Erreur lors de la suppression du type d'inspection : ${error?.message || error}`);
    } finally {
      setDeleteConfirmModal(false);
    }
  };

  const openDeleteConfirmModal = (typeId) => {
    const typeToDelete = types.find(type => type.id === typeId);
    if (typeToDelete) {
      setDeleteTargetId(typeId);
  
      setDeleteConfirmModal(true);
    }
    
  };

  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };


  const columns = useMemo(() => [
    {
      Header: "Avatar",
      accessor: "Avatar",
      Cell: ({ row }) => (
        <div className="avatar"><span>{row.original?.name.charAt(0).toUpperCase()}</span></div>
      ),
      filterable: false,
    },
    { Header: () => <div style={{ textAlign: "center" }}>{t("types.name")}</div>, accessor: "Name", Cell: ({ row }) => (
      <div className="text-center">{row.original.name || t("types.noName")}</div>),
      filterable: false },
    { Header: () => <div className="texte" style={{ textAlign: "center" }}>{t("types.description")}</div>, accessor: "description", Cell: ({ row }) => (
      <div className="text-center texte">{row.original?.description || t("types.noDescription")}</div>),
      filterable: false },
      {
        Header: () => <div style={{ textAlign: "end" }}>{t("vehicle.actions")}</div>,
        accessor: "action",
        headerStyle: { textAlign: "text-center" },
        Cell: ({ row }) => (
          <div className=" actions-cell">
            <OverlayTrigger
            placement="top" 
                  overlay={<Tooltip id="tooltip-detail">{t("vehicle.view_details")}</Tooltip>} // Contenu du tooltip
      >
        
              <EyeOutlined    style={{ color: '#1F5357', fontSize: '15px' }}  onClick={() => handleDetail(row.original)}/>
         
              </OverlayTrigger>
              <OverlayTrigger
            placement="top" // Placement du tooltip (top, bottom, left, right)
                  overlay={<Tooltip id="tooltip-detail">{t("vehicle.edit")}</Tooltip>} // Contenu du tooltip
      >
        
        <EditOutlined   style={{ color: ' #FF9800', fontSize: '15px' }}  onClick={() => handleEdit(row.original)} />
              </OverlayTrigger>
           <OverlayTrigger
           placement="top" overlay={<Tooltip id="tooltip-delete">{t("vehicle.delete")}</Tooltip>}
           >
             <DeleteOutlined style={{ color: '    #D32F2F', fontSize: '15px' }}  onClick={() => openDeleteConfirmModal(row.original.id)} />
           </OverlayTrigger>
          </div>
        ),
        filterable: false,
      },
  ], [handleDetail, openDeleteConfirmModal]);

  const HeaderTable = () => (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div className="d-flex gap-3">
        <strong>{t("types.listTitle")}</strong>
      </div>
      <button
        style={{
          padding: '5px 10px',
          borderRadius: '20px',
          backgroundColor: '#1F5357',
          color: 'white',
          border: 'none',
          fontSize: '15px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#1F5357')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#1F5357')}
        onClick={() => toggleAddEditModal(null)}
      >
        {t('types.createType')}  
      </button>
    </div>
  );

  const tabs = [t("types.all"), t("types.assigned"), t("types.unassigned"), t("types.archived")];
  const [activeTab, setActiveTab] = useState(t("types.all"));

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const filteredTypeInspections = useMemo(() => {
    if (!types) return error?.message || [];
    switch (activeTab) {
      case t("types.assigned"):
        return types.filter(v => v.types === 'Assigne');
      case t("types.unassigned"):
        return types.filter(v => v.types === 'Non assigne');
      case t("types.archived"):
        return types.filter(v => v.types === 'Archive');
      default:
        return types;
    }
  }, [types, activeTab]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("types.type")} history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={filteredTypeInspections}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={5}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    SearchPlaceholder={t("types.searchPlaceholder")}
                    HeaderTable={HeaderTable}
                  />
                  {isLoading && !isError && (
                    <div className="text-center">
                      {t("types.loading")} <Spin />
                    </div>
                  )}
                  {isError && (
                    <div className="text-center">
                      {t("types.error")}: {error?.message || error}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AddEditType
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedType={selectedType}
          />
         
           <DetailType
            modal={isDetailModalOpen}
            setModal={setIsDetailModalOpen}
            toggle={toggleDetailModal}
            selectedType={selectedType}
          />
          <Modal
            title={t("types.deleteConfirmationTitle")}
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
            footer={[
                <div className="d-flex justify-content-end gap-2 mt-3 ">
              <Button key="cancel" onClick={closeDeleteConfirmModal} className="bordered-btn-delete">
                {t("types.no")}
              </Button>
              <Button key="delete" type="danger" onClick={() => handleDelete(deleteTargetId)} className="bordered-btn">
                {t("types.yes")}
              </Button>
              </div>
            ]}
            width={400}
            style={{ top: 200 }}
          >
            <p>{t("types.deleteConfirmationMessage")}{deleteTargetFullName} ?</p>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TypeInspections;
